// theme.ts
import { createTheme } from '@mui/material/styles'

const theme = createTheme({
  palette: {
    background: {
      default: '#242424', // Customize default background
    },
    text: {
      primary: '#ffffff', // Customize primary text color
      secondary: '#777777', // Customize secondary text color
    },
  },
  typography: {
    fontFamily: 'Roboto',
  },
  components: {
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          color: '#ffffff', // Set your default icon color here
        },
      },
    },
  },
})

export default theme
